export default [
  {
    code: "31933030",
    format: "C3",
    gsm: 100,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "4040",
    format: "C4",
    gsm: 90,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "4041",
    format: "C4",
    gsm: 90,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: "envelopesProperties.print.gray",
  },
  {
    code: "4240",
    format: "C4",
    gsm: 90,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "5040",
    format: "B4",
    gsm: 100,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "5240",
    format: "B4",
    gsm: 100,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    boxSize: 200,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "31833030",
    format: "E4",
    gsm: 100,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "3044",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.pocket",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "3244",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "3404",
    format: "C5",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.gummed",
    window: null,
    print: null,
  },
  {
    code: "3428",
    format: "C5",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.selfSeal",
    window: null,
    print: null,
  },
  {
    code: "3444",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "3445",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: "envelopesProperties.print.gray",
  },
  // {
  //   code: "3464",
  //   format: "C5 mini",
  //   gsm: 75,
  //   color: "envelopesProperties.color.white",
  //   type: "envelopesProperties.type.envelope",
  //   boxSize: 500,
  //   sealing: "envelopesProperties.sealing.peelSeal",
  //   window: null,
  //   print: null,
  // },
  {
    code: "3500",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.kmp",
    window: "45x90",
    print: null,
  },
  {
    code: "3544",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: "45x90",
    print: null,
  },
  {
    code: "3644",
    format: "C5",
    gsm: 80,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  // {
  //   code: "3840",
  //   format: "B5",
  //   gsm: 90,
  //   color: "envelopesProperties.color.white",
  //   type: "envelopesProperties.type.pocket",
  //   boxSize: 500,
  //   sealing: "envelopesProperties.sealing.peelSeal",
  //   window: null,
  //   print: null,
  // },
  // {
  //   code: "3940",
  //   format: "B5",
  //   gsm: 90,
  //   color: "envelopesProperties.color.brown",
  //   type: "envelopesProperties.type.pocket",
  //   boxSize: 500,
  //   sealing: "envelopesProperties.sealing.peelSeal",
  //   window: null,
  //   print: null,
  // },
  {
    code: "2012",
    format: "DL",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.gummed",
    window: null,
    print: null,
  },
  {
    code: "2020",
    format: "DL",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.selfSeal",
    window: null,
    print: null,
  },
  {
    code: "2052",
    format: "DL",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2053",
    format: "DL",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: "envelopesProperties.print.gray",
  },
  {
    code: "2040",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2140",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: "45x90",
    print: null,
  },
  {
    code: "2260",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.envelope",
    boxSize: 800,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_021",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.orange",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_032",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.red",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_113_285",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.yellowBlue",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_238",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.rose",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_361",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.green",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_0131",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.pastelYellow",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_2717",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.pastelBlue",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_531",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.pastelLavender",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_573",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.pastelMint",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2240_7507",
    format: "DL",
    gsm: 80,
    color: "envelopesProperties.color.pastelCreme",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "2014-1",
    format: "DL",
    gsm: 75,
    color: "envelopesProperties.color.embroidery",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.gummed",
    window: null,
    print: null,
  },
  {
    code: "2500",
    format: "C65",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.kmp",
    window: null,
    print: null,
  },
  {
    code: "2600",
    format: "C65",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.kmp",
    window: "45x90",
    print: null,
  },
  {
    code: "2608",
    format: "C65",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.kmp",
    window: "45x90",
    print: null,
  },
  {
    code: "1012",
    format: "C6",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.gummed",
    window: null,
    print: null,
  },
  {
    code: "1020",
    format: "C6",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.selfSeal",
    window: null,
    print: null,
  },
  {
    code: "1040",
    format: "C6",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "1041",
    format: "C6",
    gsm: 75,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: "envelopesProperties.print.gray",
  },
  {
    code: "1044",
    format: "C6",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "1064",
    format: "C6",
    gsm: 75,
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.gummed",
    window: null,
    print: null,
  },
  {
    code: "1740",
    format: "E6",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 500,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  {
    code: "6112",
    format: "СD",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.gummed",
    window: "90",
    print: null,
  },
  {
    code: "6040",
    format: "СD",
    gsm: 80,
    color: "envelopesProperties.color.white",
    type: "envelopesProperties.type.envelope",
    boxSize: 1000,
    sealing: "envelopesProperties.sealing.peelSeal",
    window: null,
    print: null,
  },
  // {
  //   code: "6044",
  //   format: "150x150",
  //   gsm: 80,
  //   color: "envelopesProperties.color.white",
  //   type: "envelopesProperties.type.envelope",
  //   boxSize: 1000,
  //   sealing: "envelopesProperties.sealing.peelSeal",
  //   window: null,
  //   print: null,
  // },
  // {
  //   code: "6244",
  //   format: "150x150",
  //   gsm: 80,
  //   color: "envelopesProperties.color.brown",
  //   type: "envelopesProperties.type.envelope",
  //   boxSize: 1000,
  //   sealing: "envelopesProperties.sealing.peelSeal",
  //   window: null,
  //   print: null,
  // },
]
